"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Select = ({
  id,
  label,
  input,
  tabIndex,
  options,
  showEmptyValue,
  emptyValueLabel,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledSelect, { ...input,
  id: id,
  tabIndex: tabIndex,
  ...otherProps,
  children: [showEmptyValue && /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
    value: "",
    children: emptyValueLabel
  }), options.map((option, index) => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
      value: option.value,
      disabled: option.disabled,
      children: option.label
    }, index);
  })]
});

Select.propTypes = {
  input: _propTypes.default.object,
  tabIndex: _propTypes.default.number,
  options: _propTypes.default.array,
  showEmptyValue: _propTypes.default.bool,
  emptyValueLabel: _propTypes.default.string
};
Select.defaultProps = {
  showEmptyValue: true,
  emptyValueLabel: 'Please select...'
};
var _default = Select;
exports.default = _default;